import { authLabels } from "@/i18n";
import { getLanguage } from "@/utils/languageUtils";

const NativeAppSkeleton = () => {
  const label =
    authLabels(getLanguage()).login?.loading ?? "Laddar...";

  return (
    <div
      className="native-auth-skeleton fixed inset-0 z-[200] flex flex-col items-center justify-center bg-background"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="text-2xl font-bold tracking-[0.2em] text-foreground mb-6 animate-pulse">
        BILENIA
      </div>
      <div className="h-8 w-8 rounded-full border-2 border-muted-foreground/30 border-t-accent animate-spin" />
      <p className="mt-4 text-sm text-muted-foreground">{label}</p>
    </div>
  );
};

export default NativeAppSkeleton;
